<template>
  <v-dialog
    v-model="visibilidade"
    max-width="600"
    persistent
  >
    <v-form
      ref="form"
      @submit.prevent="onSubmit"
    >
      <v-card class="pa-4">
        <v-card-text>
          <v-row>
            <h4 class="headline primary--text text-no-wrap">
              {{ isEdicao ? "Editar" : "Adicionar" }} Competência Técnica
            </h4>
          </v-row>
          <v-row>
            Digite o nome da competência a ser
            {{ isEdicao ? "editada" : "adicionada" }}
          </v-row>
          <v-row class="mt-8">
            <v-text-field
              v-model.trim="nomeCompetencia"
              autofocus
              label="Nome"
            />
          </v-row>
        </v-card-text>
        <v-spacer />
        <v-card-actions>
          <v-spacer />
          <v-btn
            :disabled="nomeCompetencia.trim() === ''"
            color="primary"
            type="submit"
          >
            {{ isEdicao ? "Editar" : "Adicionar" }}
          </v-btn>
          <v-btn
            color="primary"
            outlined
            @click="toogle"
          >
            Cancelar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import { RepositoryFactory } from '@/repositories/RepositoryFactory';

const competenciaTecnicaRepository = RepositoryFactory.get('competenciaTecnica');

export default {
  name: 'CadastroEdicaoCompetencia',

  props: {
    competencia: {
      type: Object,
      required: true,
      default: () => null,
    },
    visibilidade: {
      type: Boolean,
      required: true,
      default: false,
    },
    toogle: {
      type: Function,
      default: () => {},
    },
    isEdicao: {
      type: Boolean,
      required: true,
      default: false,
    },
    mapeamento: {
      type: Object,
      required: true,
      default: () => {},
    },
    etapa: {
      type: String,
      required: true,
    },
    unidadesSelecionadas: {
      type: Array,
      required: false,
      default: () => ([]),
    },
  },

  data() {
    return {
      nomeCompetencia: '',
    };
  },

  computed: {
    competenciasTecnicas: {
      get() {
        return this.$store.state.competencia.competenciasTecnicas;
      },
      set(value) {
        const payload = { tipo: 'TECNICA', competencias: value.sort((a, b) => a.nome.localeCompare(b.nome)) };
        this.$store.dispatch('competencia/setCompetencias', payload);
      },
    },
  },

  watch: {
    competencia() {
      switch (this.etapa) {
        case 'normalizacao':
          this.nomeCompetencia = this.competencia.nomeNormalizacao
            ? this.competencia.nomeNormalizacao
            : this.competencia.nomeAtual;
          break;
        case 'validacao':
          this.nomeCompetencia = this.competencia.nomeValidacao
            ? this.competencia.nomeValidacao
            : this.competencia.nomeAtual;
          break;
        case 'consolidacao':
          this.nomeCompetencia = this.competencia.nomeConsolidacao
            ? this.competencia.nomeConsolidacao
            : this.competencia.nomeAtual;
          break;
        default:
          this.nomeCompetencia = '';
      }
    },
  },

  methods: {
    onSubmit() {
      if (this.competencia && this.nomeCompetencia.trim() !== '') {
        this.competencia.mapeamento = this.mapeamento;
        if (this.isEdicao) {
          switch (this.etapa) {
            case 'normalizacao':
              this.competencia.nomeNormalizacao = this.nomeCompetencia;
              break;
            case 'validacao':
              this.competencia.nomeValidacao = this.nomeCompetencia;
              break;
            case 'consolidacao':
              this.competencia.nomeConsolidacao = this.nomeCompetencia;
              break;
            default:
              break;
          }

          competenciaTecnicaRepository
            .update(this.competencia.id, this.unidadesSelecionadas, this.competencia)
            .then(async (res) => {
              const retorno = res.data;
              const competencia = retorno.find((c) => c.id === this.competencia.id);
              const index = this.competenciasTecnicas.findIndex((c) => c.id === competencia.id);
              this.competenciasTecnicas.splice(index, 1, competencia);

              if (retorno.length > 1) {
                const competenciaNova = retorno.find((c) => c.id !== competencia.id);
                this.competenciasTecnicas.push(competenciaNova);
              }
              this.nomeCompetencia = '';
              await this.$store.dispatch('responsabilidade/load', { mapeamento: this.mapeamento.id, comissao: true });
              await this.$store.dispatch('app/success', { response: res, message: 'Competência editada com sucesso!' });
              this.$emit('hide');
            });
        } else {
          this.competencia.nome = this.nomeCompetencia;
          competenciaTecnicaRepository.create(this.competencia).then((res) => {
            const competenciaCriada = res.data;
            this.competenciasTecnicas.push(competenciaCriada);
            this.nomeCompetencia = '';
            this.$emit('hide');
            this.$emit('return', competenciaCriada);
            this.$store.dispatch('app/success', { response: res, message: 'Competência adicionada com sucesso!' });
          });
        }
      }
    },
  },
};
</script>
